import { render, staticRenderFns } from "./clockIcon.vue?vue&type=template&id=0a1f5454&"
import script from "./clockIcon.vue?vue&type=script&lang=js&"
export * from "./clockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports